import React, { Component } from "react";
import { connect } from "react-redux";
import "./content.scss";
import socialIcon from "../../../assets/svg/socialtokensBlue.svg";
import { Link } from "react-router-dom";
import connectImg from "../../../assets/connect-your-account.png";
import { Dimmer, Loader } from "semantic-ui-react";
import { setActiveModule } from "../../../actions/sideBarActions";
class ConnectAccount extends Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    componentDidMount() {}
    handleButton = () => {
        localStorage.setItem("activeModule", "Listening");
        this.props.setActiveModule("Listening");
    };

    render() {
        return (
            <>
                <div className="gs_content">
                    <div className="left_content">
                        <div className="gs_header">
                            <img src={socialIcon} className="icon_content" />
                            <span className="content_title">Social Tokens</span>
                        </div>
                        <div className="text_content">
                            <p>{`We can fetch a lot of your data if you authenticate your pages and accounts. `} </p>
                            <p>{`Please ensure that you authenticate all your pages and accounts.  `}</p>
                            <p>{`Without this, your data will be limited. Really!`}</p>

                            <p>{`So what are you waiting for?  Just visit this section and authenticate yourself!`}</p>
                        </div>
                        <Link to="/social-tokens">
                            <button onClick={this.handleButton} className="gs_link">
                                Connect Social Accounts
                            </button>
                        </Link>
                    </div>
                    <div className="right_content">
                        <div id="gs_loader">
                            <Dimmer inverted active>
                                <Loader size="big skiptranslate">Loading</Loader>
                            </Dimmer>
                        </div>
                        <iframe
                            width="320px"
                            height="200px"
                            src="https://www.youtube.com/embed/yb8sej6deaM?modestbranding=1"
                            title=""
                            frameBorder="0"
                            allow="accelerometer; autoplay; clipboard-write; gyroscope; picture-in-picture"
                            allowFullScreen
                            onLoad={() => (document.getElementById("gs_loader").style.display = "none")}
                            className="content_video"></iframe>
                        {/* <img className="content-img" src={connectImg} width="350px" height="200px" /> */}
                    </div>
                </div>
            </>
        );
    }
}

const mapStateToProps = (state) => {
    return {};
};

const mapDispatchToProps = (dispatch) => {
    return {
        setActiveModule: (data) => dispatch(setActiveModule(data)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(ConnectAccount);
